import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text } from 'components/ui';
import CompareZoneBase from 'components/Catalog/ProductGrid/CompareModal/Zones/CompareZoneBase';

const OverviewZone = ({ selectedProducts = [], getText = () => {} }) => {
    const renderContent = () => {
        return (
            <Text
                fontSize='sm'
                color='gray'
            >
                Overview Zone
            </Text>
        );
    };

    return (
        <CompareZoneBase
            selectedProducts={selectedProducts}
            getText={getText}
            titleKey='overview'
            renderContent={renderContent}
        />
    );
};

OverviewZone.propTypes = {
    selectedProducts: PropTypes.arrayOf(PropTypes.object),
    getText: PropTypes.func
};

export default wrapFunctionalComponent(OverviewZone, 'OverviewZone');
